module.exports = __webpack_public_path__ + "img/C07TechLongshipChampion_ua.a531e60b.webp";